import { APIDownError, CartConfirmationUrl, CheckoutSummaryAgreementCheckBoxError } from "../directives/utilities/urls";
export default function activityCartSummary() {
    return {
        cardListDetails:[] ,
        phoneDetails: [],
        adddressPhoneDetails: [],
        adddressDetailsData:'',
        showErrorMesage: "",
        message: "",
        lineItems: [],
        hasMore: false,
        showLoader: false,
        total_Amount: '',
        isSubmitting: false,
        profileList: '',
        peopleList: '',
        addressDetails: '',
        localAddress: '',
        permanentAddress: '',
        phoneDetails: '',
        people: '',
        addedCoursesList: [],
        waitListCoursesList: [],
        selectedAgreementChecked:false,
        bindCardDetails() {
            this.showLoader = true;

            fetch("/api/Checkout/card-details", {
                method: "get",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                }
            })
                .then((response) => {

                    return response.json();
                })
                .then((response) => {

                    this.showLoader = false;
                   
                    if (response != undefined) {

                        this.cardListDetails = response;

                    } else {
                        this.showErrorMesage = APIDownError;
                    }
                });
        },
      
        bindCartList() {
           
            this.showLoader = true;
            this.waitlistCartList = [];
            this.enrollmentCartList = [];
            fetch("/api/Checkout/fee-summary", {
                method: "get",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                }
            })
                .then((response) => {

                    return response.json();
                })
                .then((response) => {
                    this.showLoader = false;

                    if (response != undefined && response.isSuccess) {

                        if (response.lineItems.length > 0) {
                            this.total_Amount = response.lineItems.reduce((sum, item) => sum += item.fee, 0);
                            Array.prototype.push.apply(this.lineItems, response.lineItems);
                        } else {
                            this.showErrorMesage = "Your cart is empty.";
                        }
                    } else {
                        this.showErrorMesage = APIDownError;
                    }
                });
        },
        validateNextStep() {
            if (this.selectedAgreementChecked == false) {
                this.message = CheckoutSummaryAgreementCheckBoxError;
                return false;

            } else {
                
                document.getElementById('btnSubmit').click();
            }
        },
        nextStep() {

          
            this.message = "";
            this.isSubmitting = true;

            fetch('/api/Checkout/CompleteCheckout', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    AgreementChecked: this.selectedAgreementChecked,
                    SessionId: '1111',
                    SecurityCode: 111,
                    IpAddress: document.getElementById('ipAddress').value
                })


            }).then(response => {
                return response.json();
            }).then(result => {
   
                document.getElementsByClassName("f-button is-close-btn")[0].click();
                if (result.isSuccess && result.checkoutConfirmed) {
                    document.location.href = CartConfirmationUrl; 
                }
                else {
                    
                    document.getElementById('btnFailedMessage').click();
                    this.message = result.message;
                }
                this.isSubmitting = false;
              
            })
        },
        bindWaitingCartList() {
       
            var jsonData = JSON.stringify({
                SessionId: "",
                CartRequestType: 2
            });
            this.showLoader = true;
            this.waitlistCartList = [];
            fetch("/api/Checkout/cart", {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: jsonData,
            })
                .then((response) => {
                    return response.json();
                })
                .then((response) => {
                    this.showLoader = false;
                    if (response != undefined && response.isSuccess) {

                        if (response.cartItems.length > 0) {
                            for (var item = 0; item < response.cartItems.length; item++) {
                                if (response.cartItems[item].actionType == "W") {

                                    this.waitlistCartList.push(response.cartItems[item]);
                                }
                            } this.showErrorMesage = "";
                        } else {
                            this.showErrorMesage = "Your cart is empty.";
                        }
                    } else {
                        this.showErrorMesage = APIDownError;
                    }
                });
        },
        bindAssessCart() {
            fetch('/api/Checkout/assess-cart', { "method": "GET" })
                .then(response => {
                    return response.json();
                }).then(login => {

                })
        },

        bindProfile() {

            fetch('/api/UserAPI/GetProfile', { "method": "GET" })
                .then(response => {
                    if (response.ok) {
                        return response.json()
                    }
                }).then(response => {
                    if (response != undefined && response.isSuccess) {
                        this.peopleList = response.people;
                        //                        If 1 then show Local Address object
                        //If 2 then Business Address
                        //If 3 then Permanent Address
                        if (response.people.preferredAddressType == 1) {
                            this.addressDetails = response.localAddress;
                        } else if (response.people.preferredAddressType == 2) {
                            this.addressDetails = response.businessAddress;
                        } else {
                            this.addressDetails = response.permanentAddress;
                        }
                        this.phoneDetails = response.phoneDetails;
                       
                        if (this.addressDetails.address1 != '') {
                            this.adddressDetailsData = this.addressDetails.address1;
                        }
                        if (this.addressDetails.address2 != '') {
                            this.adddressDetailsData = this.adddressDetailsData + "<br/>" + this.addressDetails.address2;
                        }
                        if (this.addressDetails.address3 != '') {
                            this.adddressDetailsData = this.adddressDetailsData + "<br/>" + this.addressDetails.address3;
                        }

                    
                       
                        this.people = response.people;
                        sessionStorage.setItem('addressDetails', JSON.stringify(this.addressDetails));
                        sessionStorage.setItem('phoneDetails', JSON.stringify(this.phoneDetails));

                    } else {
                        this.showErrorMesage = APIDownError;
                    }

                });

        },
        btnCancelClick() {
            document.location.href = '/api/login/SignOut';
        },
      
          formatDate(dateValue) {
            const date = new Date(dateValue);
            const month = date.getMonth() + 1; // Month is zero-based, so add 1
            const day = date.getDate();
            const year = date.getFullYear();
            return `${month}/${day}/${year}`;
        },
        init() {           
            this.bindProfile();
            this.bindCardDetails();
            this.bindCartList();
            this.bindWaitingCartList();
        },
    };
}
